import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NotificationService } from '@pansa/ui';
import { catchError, throwError } from 'rxjs';

export const errorInterceptorFn: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationService);

  return next(req).pipe(
    catchError((error) => {
      let message = 'Wystąpił błąd podczas wykonywania operacji';

      if (typeof error.error === 'string') {
        message = error.error;
      } else if (error.error && typeof error.error === 'object') {
        message = Object.entries(error.error)
          .map(([key, value]) => `${key}: ${value}`)
          .join('\n');
      } else if (error.message) {
        message = error.message;
      }

      notificationService.danger({
        title: 'Wystąpił błąd',
        subTitle: message
      });

      return throwError(() => error);
    })
  );
};
